export const prepareRoles = (roles = []) => {
  return roles.map((e) => ({
    id: e?.id,
    name: e?.name,
    description: e?.description
  }));
};